<template>
  <div>
    <StaticDataTable class="static-table-list">
      <template v-slot:header>
        <tr>
          <th width="23%" colspan="2"><Tooltip label="Stock thickness range this guideline applies to. Minimum is inclusive, maximum is exclusive" helpStyle>Thickness Range</Tooltip></th>
          <th width="8%"><Tooltip label="Glass type this guideline applies to" helpStyle>Glass Type</Tooltip></th>
          <th width="11%"><Tooltip label="Minimum distance required (inclusive) between the nearest edge of two center cutouts" helpStyle>Edge to Edge Clearance</Tooltip></th>
          <th width="11%"><Tooltip label="Minimum distance required (inclusive) between the nearest edge of a center cutout the panel edge" helpStyle>Edge Clearance</Tooltip></th>
          <th width="11%"><Tooltip label="Minimum distance required (inclusive) between the nearest edge of a center cutout and a corner of the panel (including corner/edge cutouts)" helpStyle>Corner Clearance</Tooltip></th>
          <th width="8%">
            <Tooltip label="Uses a percentage of the corner radius circumference as a test value. If less than, uses the below minimum radius. If greater or equal to, used the above minimum radius" helpStyle>Corner Radius Test</Tooltip>
          </th>
          <th width="22%" colspan="2">
            <Tooltip label="Uses a percentage of the corner radius circumference as a test value. If less than, uses the below minimum radius. If greater or equal to, used the above minimum radius" helpStyle>Corner Radius Minimum</Tooltip>
          </th>
          <th width="5%" v-if="editing">Actions</th>          
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="guideline in guidelineList" :key="guideline.id">
          <td v-if="editing">
            <FormInputText type="number" v-model="guideline.minThickness" @input="listUpdated" prepend="Min" addon="mm" />
          </td>
          <td v-if="editing">
            <FormInputText type="number" v-model="guideline.maxThickness" @input="listUpdated" prepend="Max" addon="mm" />
          </td>
          <td v-if="!editing" colspan="2">{{guideline.minThickness}}mm - {{guideline.maxThickness}}mm</td>

          <td v-if="editing">
            <FormSelect v-model="guideline.glassType" :options="GlassTypeLookup" @input="listUpdated" placeholder="Glass Type" field="glassType" />
          </td>
          <td v-if="!editing">{{formatLookupName(guideline.glassType, GlassTypeLookup)}}</td>

          <td>
            <FormInputText v-if="editing" type="number" v-model="guideline.minCenterEdgeToEdgeClearance" @input="listUpdated" addon="mm" />
            <span v-if="!editing">{{guideline.minCenterEdgeToEdgeClearance}}mm</span>
          </td>
          <td>
            <FormInputText v-if="editing" type="number" v-model="guideline.minCenterEdgeClearance" @input="listUpdated" addon="mm" />
            <span v-if="!editing">{{guideline.minCenterEdgeClearance}}mm</span>
          </td>
          <td>
            <FormInputText v-if="editing" type="number" v-model="guideline.minCenterCornerClearance" @input="listUpdated" addon="mm" />
            <span v-if="!editing">{{guideline.minCenterCornerClearance}}mm</span>
          </td>
          <td v-if="editing">
            <FormInputText v-if="editing" type="number" v-model="guideline.cornerRadiusTestPercent" @input="listUpdated" addon="%" />            
          </td>
          <td v-if="!editing">
            {{guideline.cornerRadiusTestPercent}}%
          </td>
          <td v-if="editing">
            <FormInputText v-if="editing" type="number" v-model="guideline.minRadiusBelowPercent" @input="listUpdated" :prepend="`&lt; ${guideline.cornerRadiusTestPercent || 0}%`" addon="mm" />            
          </td>
          <td v-if="editing">
            <FormInputText v-if="editing" type="number" v-model="guideline.minRadiusAbovePercent" @input="listUpdated" :prepend="`&gt;= ${guideline.cornerRadiusTestPercent || 0}%`" addon="mm" />            
          </td>
          <td v-if="!editing" colspan="2">
            If corner radius less than <strong>{{guideline.cornerRadiusTestPercent}}%</strong>, min radius is <strong>{{guideline.minRadiusBelowPercent}}mm</strong><br />
            If corner radius is greater or equal to <strong>{{guideline.cornerRadiusTestPercent}}%</strong>, min Radius is <strong>{{guideline.minRadiusAbovePercent}}mm</strong>
          </td>
          <td v-if="editing">
            <ActionDropMenu :tableAction="true">
              <DropdownMenuItem @click="deleteGuideline(guideline.id)" icon="fa-trash-alt">Delete</DropdownMenuItem>
            </ActionDropMenu>
          </td>
        </tr>
      </template>
      <template v-slot:empty v-if="guidelineList.length == 0">
        No guidelines found
      </template>
    </StaticDataTable>
    <button v-if="editing" class="btn btn-white btn-xs" @click.prevent="addGuideline"><i class="far fa-plus"></i> Add Guideline</button>
  </div>
</template>


<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import formMixin from '@/mixins/form'
import { GlassTypes, GlassTypeLookup } from '@/store/types'

export default {
  name: 'OrderEditorGuidelineEditor',
  model: {
    event: 'update'
  },
  mixins: [formMixin],
  props: {
    editing: Boolean,
    value: Array
  },
  data() {
    return {
      guidelineList: []
    }
  },
  computed: {
    
  },
  watch: {
    value: function() {
      this.$data.guidelineList = _.cloneDeep(this.$props.value)
    }
  },
  created() {
    this.GlassTypes = GlassTypes
    this.GlassTypeLookup = GlassTypeLookup
  },
  mounted() {
  },
  methods: {
    addGuideline() {
      this.guidelineList.push({
        id: `temp-id-` + uuidv4(),
        isNew: true,
        minThickness: 0,
        maxThickness: 0,
        glassType: GlassTypes.all,
        minCenterEdgeToEdgeClearance: 0,
        minCenterEdgeClearance: 0,
        minCenterCornerClearance: 0,
        cornerRadiusTestPercent: 0,
        minRadiusBelowPercent: 0,
        minRadiusAbovePercent: 0
      })
      this.listUpdated()
    },
    deleteGuideline(id) {
      this.guidelineList = this.guidelineList.filter(guideline => guideline.id != id)
      this.listUpdated()
    },
    listUpdated() {
      this.$emit('update', this.guidelineList)
    }
  }


}
</script>